import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  queues: [],
  last_queue: 1,
  form: {
    data: {}
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};


// WEBPACK FOOTER //
// ./src/store/fcfs/index.js